import React from 'react'
import styles from './SettledBeneficiary.module.scss'
import { currencyUtils } from '../../../../../../utils'

interface ISettledBeneficiaryProps {
  amountPayable: number
}

const SettledBeneficiary = ({ amountPayable }: ISettledBeneficiaryProps) => {
  return (
    <div className={styles.root}>
      <span className={styles['text-wrapper']}>
        <span className={styles.header}>Settled</span>
        <span className={styles.body}>{currencyUtils.formatCurrency(amountPayable)} paid</span>
      </span>
      <span className={styles['check-icon']} />
    </div>
  )
}

export default SettledBeneficiary
